import React from 'react';

export function ScreenerPresentedBy({ link, logo }: { link?: string | null; logo: string }) {
  const content = (
    <>
      <span className="calendar-presented-by__label">Presented by</span>
      <img alt="" className="calendar-presented-by__logo !max-w-[180px]" src={logo} />
    </>
  );

  return link ? (
    <a className="calendar-presented-by no-underline" href={link} target="_blank">
      {content}
    </a>
  ) : (
    <div className="calendar-presented-by">{content}</div>
  );
}
